module.exports = __webpack_public_path__ + "static/thesisEnglish-eba3a2fb06fba4a4394d9cbfbc3935ab.pdf";